import React from 'react';
import ScalingComponent from './Size/Scaling';
import Properties from './Properties/Properties';
import Effects from './Effects/Effects';
import ButtonContent from './Button/ButtonContents';
import Action from './Action/Action';
import { ImageElementType } from '../../redux/TabTile/TabStateInterfaces';

interface ControlDetailProps {
  selectedOption: string;
  selectedImageId: string | null;
  updateScaling: (id: string, scalingType: string) => void;
  imageElements: ImageElementType[];
  onUpdateImageElements: (updated: ImageElementType[]) => void;
  iconColor?: string;
  backgroundColor?: string;
  selectedTabBackgroundColor?: string;
}

const ControlDetail: React.FC<ControlDetailProps> = ({
  selectedOption,
  selectedImageId,
  imageElements,
  updateScaling,
  onUpdateImageElements,
  iconColor,
  backgroundColor,
  selectedTabBackgroundColor,
}) => {
  const selectedImage = imageElements.find((img) => img.id === selectedImageId);

  const updateImage = (updates: Partial<ImageElementType>) => {
    const updatedList = imageElements.map((img) =>
      img.id === selectedImageId ? { ...img, ...updates } : img,
    );
    onUpdateImageElements(updatedList);
  };

  switch (selectedOption) {
    case 'Size':
      return (
        <ScalingComponent
          selectedImageId={selectedImageId}
          imageElements={imageElements}
          updateScaling={updateScaling}
          color={iconColor}
        />
      );

    case 'Content':
      return (
        selectedImage && (
          <ButtonContent
            selectedImage={selectedImage}
            updateImage={updateImage}
            iconColor={iconColor}
            backgroundColor={backgroundColor}
            selectedTabBackgroundColor={selectedTabBackgroundColor}
          />
        )
      );

    case 'Properties':
      return <Properties iconColor={iconColor} backgroundColor={backgroundColor} />;

    case 'Effects':
      return (
        <Effects
          iconColor={iconColor}
          selectedImageId={selectedImageId}
          imageElements={imageElements}
          onUpdateImageElement={(id, updates) => {
            const updatedList = imageElements.map((img) =>
              img.id === id ? { ...img, ...updates } : img,
            );
            onUpdateImageElements(updatedList);
          }}
        />
      );

    case 'Action':
      return (
        selectedImage && (
          <Action
            iconColor={iconColor}
            selectedImage={selectedImage}
            updateImage={updateImage}
            selectedImageId={selectedImageId}
          />
        )
      );

    default:
      return <div>Select a section</div>;
  }
};

export default ControlDetail;
